import React, { useMemo } from "react";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { makeStyles } from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import clsx from "clsx";
import { GENERAL_STYLES } from "styles/common";
import filter from "../../assets/img/filter.svg";

type StyleProps = { color?: string; backgroundColor?: string };

const useStyles = makeStyles<StyleProps>((theme) => ({
  button: {
    borderRadius: GENERAL_STYLES.general.borderRadius,
    textTransform: "none",
    color: ({ color }: StyleProps) => color ?? "#000",
    backgroundColor: ({ backgroundColor }: StyleProps) =>
      backgroundColor ?? "#FFF",
    minHeight: 40,
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
      opacity: "0.8",
    },
    "& .MuiButton-endIcon": {
      marginLeft: "auto",
      marginRight: 0,
    },
    "&.MuiButton-contained.Mui-disabled": {
      color: "rgba(0, 0, 0, 0.26)",
      boxShadow: "none",
      background: "rgba(0, 0, 0, 0.12)",
    },
  },
}));

export const CustomButton = React.forwardRef<any, any>((props: any, ref) => {
  const color = useMemo(() => {
    switch (props.color) {
      case "error":
        return "rgba(255, 76, 86, 1)";
      case "black":
        return "rgba(255, 255, 255, 1)";
      case "secondary":
        return "#000";
      default:
        return props.color ? "#8214DC" : "#000";
    }
  }, [props.color]);

  const backgroundColor = useMemo(() => {
    if (props.variant === "text") return "transparent";
    switch (props.color) {
      case "error":
        return "rgba(255, 246, 247, 1)";
      case "black":
        return "rgba(0, 0, 0, 1)";
      case "secondary":
        return "#FCFF00";
      default:
        return props.color === "default" && "rgba(75, 100, 255, 0.05)";
    }
  }, [props.color]);

  const classes = useStyles({ color, backgroundColor } as StyleProps);

  return (
    <Button
      ref={ref}
      color="secondary"
      variant="contained"
      disabled={props.disabled}
      startIcon={
        props.withplus ? (
          <AddIcon />
        ) : props.isedit ? (
          <EditIcon />
        ) : props.startfiltericon ? (
          <img src={filter} alt="filter" />
        ) : null
      }
      endIcon={
        props.endarrow ? <ArrowForwardIcon style={{ fontSize: 24 }} /> : null
      }
      {...props}
      style={{ ...props.style, opacity: props.disabled ? 0.4 : 1 }}
      className={clsx(classes.button, props.className)}
    >
      {props.text || props.children}
    </Button>
  );
});
